import { useState, useEffect } from "react";

// Delays updating the returned value until `value` has stopped changing for
// `delay` ms — used to avoid firing a backend search request on every
// keystroke while still keeping the input itself instantly responsive.
export const useDebouncedValue = (value, delay = 400) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
};
